import { ClearAction } from '../clear-action/clear-action';
import { ModelAction } from '../model-action/model-action';
import { PDFAction } from '../pdf-action/pdf-action';
import { ShareAction } from '../share-action/share-action';
import { SideActions } from '../side-actions/side-actions';
import styles from './actions.module.css';

export const Actions = () => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.actions}>
				<SideActions />
				<div className={styles.actionsGroup}>
					<PDFAction />
					<ModelAction />
					<ShareAction />
				</div>
				<ClearAction />
			</div>
		</div>
	);
};
